import React from 'react';
import { Elements as StripeElements } from '@stripe/react-stripe-js';

import StripeCheckoutModal from './StripeCheckoutModal';
import { StripeInstance } from '../../../util/config';

const StripeCheckout = () => {
  return (
    <StripeElements stripe={StripeInstance}>
      <StripeCheckoutModal />
    </StripeElements>
  );
};

export default StripeCheckout;
